import React from 'react';

export const Search = (props:{}) => {
    return <>Test stuffz</>;
}

export default Search;